export default "/img/SM.f824b5ae8ead366c9006d3e5bcd00f44.png";